<template>
  <div :class="className" ref="echartsMap" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
// import "echarts/map/js/china.js";
import chartResize from "./mixins/chart-resize";
import china from "../../../../public/lib/echart/json/china.json";
const _ = require("lodash");
export default {
  name: "ChinaMapEchart",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "中国地图",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "日期",
    },
    yAxisName: {
      type: String,
      default: "数量",
    },
    // visualMapMax:{
    //   type: Number,
    //   default: 100,
    // }
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        if(this.chart == null){
          this.initChart()
        }
        this.chart.clear();
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.echartsMap);
      console.log(china)
      echarts.registerMap("china", china);
      this.setOptions(this.chartData);
    },
    setOptions() {
      const that = this;
      var series = [],visualMapMax = 100;
      if(that.chartData.length){
        visualMapMax = _.sumBy(that.chartData, 'count')
        // visualMapMax = _.maxBy(that.chartData, 'count')
        console.log(visualMapMax)
        // let currentProviceIndex = _.findIndex(that.chartData, ['code', this.config.area.provinceCode]);
          series.push(
            {
              type: "lines",
              zlevel: 2,
              effect: {
                show: true,
                period: 4, //箭头指向速度，值越小速度越快
                trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
                symbol: "arrow", //箭头图标
                symbolSize: 5, //图标大小
              },
              lineStyle: {
                normal: {
                  width: 1, //尾迹线条宽度
                  opacity: 1, //尾迹线条透明度
                  curveness: 0.3, //尾迹线条曲直度
                },
              },
              data: that.convertData(that.chartData),
            },
            {
              type: "effectScatter",
              coordinateSystem: "geo",
              zlevel: 2,
              rippleEffect: {
                //涟漪特效
                period: 4, //动画时间，值越小速度越快
                brushType: "stroke", //波纹绘制方式 stroke, fill
                scale: 4, //波纹圆环最大限制，值越大波纹越大
              },
              label: {
                normal: {
                  show: true,
                  position: "left", //显示位置
                  offset: [5, 0], //偏移设置
                  formatter: function (params) {
                    //圆环显示文字
                    return params.data.name;
                  },
                  fontSize: 13,
                },
                emphasis: {
                  show: true,
                },
              },
              symbol: "circle",
              symbolSize: 5,
              itemStyle: {
                normal: {
                  show: false,
                  color: "#f00",
                },
              },
              data: that.chartData.map(function (dataItem) {
                if(dataItem.poi != null){
                  return {
                    name: dataItem.name,
                    value: dataItem.poi&&dataItem.poi.split(',').concat([
                      dataItem.count,
                    ]) || '',
                  };
                }
              }),
            },
            //被攻击点
            {
              type: "scatter",
              coordinateSystem: "geo",
              zlevel: 2,
              rippleEffect: {
                period: 4,
                brushType: "stroke",
                scale: 4,
              },
              label: {
                normal: {
                  show: true,
                  position: "bottom",
                  //offset:[5, 0],
                  color: "#0f0",
                  formatter: "{b}",
                  textStyle: {
                    color: "inherit",
                  },
                },
                emphasis: {
                  show: true,
                },
              },
              itemStyle: {
                color: "#0f0"
              },
              symbol: "pin",
              symbolSize: 50,
              data: [
                {
                  name: this.config.area.name,
                  value: this.config.area.poi.split(',').concat([visualMapMax]),
                },
              ],
            }
          );
      }
      that.chart.setOption({
        tooltip: {
          show:true,
          trigger: "item",
          backgroundColor: "rgba(166, 200, 76, 0.82)",
          borderColor: "#FFFFCC",
          showDelay: 0,
          hideDelay: 0,
          enterable: true,
          transitionDuration: 0,
          extraCssText: "z-index:100",
          formatter: function (params) {
            console.log(params)
            //根据业务自己拓展要显示的内容
            var res = "";
            var name = params.name;
            var value = params.value;
            if(typeof(value) != 'number'){
              value = params.value[2]
            }
            res = "<span style='color:#fff;'>" +
              name +
              "</span><br/>数据：" +
              value;

            return res;
          },
        },
        visualMap: {
          //图例值控制
          min: 0,
          max: visualMapMax,
          calculable: true,
          show: true,
          color: ["#f44336", "#fc9700", "#ffde00", "#ffde00", "#00eaff"],
          textStyle: {
            color: "#fff",
          },
        },
        geo: {
          map: "china",
          zoom: 1.2,
          label: {
            emphasis: {
              show: false,
            },
          },
          roam: true, //是否允许缩放
          itemStyle: {
            normal: {
              color: "rgba(51, 69, 89, .5)", //地图背景色
              borderColor: "#516a89", //省市边界线00fcff 516a89
              borderWidth: 1,
            },
            emphasis: {
              color: "rgba(37, 43, 61, .5)", //悬浮背景
            },
          },
        },
        series: series,
      });
    },
    convertData(data) {
      const that = this;
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var dataItem = data[i];
         if(dataItem.poi != null){
          var fromCoord = dataItem.poi.split(',');
          var toCoord = this.config.area.poi.split(',');
          if (fromCoord && toCoord) {
            res.push([
              {
                coord: fromCoord,
                value: dataItem.count,
                name:dataItem.name
              },
              {
                coord: toCoord,
              },
            ]);
          }
        }
      }
      return res;
    },
  },
};
</script>
